import React, {useEffect, useState} from 'react';
import {Pie} from 'react-chartjs-2';
import 'chartjs-plugin-piechart-outlabels';
import ReportPieChart from "../../module/report/components/reports/ReportPieChart";
import MyTicketSkeleton from "../../module/squareOfSolidarity/component/skeleton/MyTicketSkeleton";
const PieChart = ({data, chartId, exports}) => {

    const options = {
        maintainAspectRatio: true,
        responsive: true,
        rtl: true,
        legend: {
            display: false,
            arc: true
        },

        layout: {
            padding: 30
        },
        plugins: {
            datalabels: {
                display: true,
                color: '#fff'
            },
            outlabels: {
                backgroundColor: "transparent", // Background color of Label
                borderColor: "transparent", // Border color of Label
                borderRadius: 0, // Border radius of Label
                borderWidth: 0, // Thickness of border
                display: true,
                lineWidth: 1, // Thickness of line between chart arc and Label
                padding: 0,
                textAlign: "center",
                text: function(){
                    return '%l  \n %v'
                },
                arc:true,
                color: '#d9d9d9',
                stretch: 20,
                fontWeight:500,
                zoomOutPercentage : 10,
                font: {
                    resizable: true,
                    minSize: 13 ,
                    maxSize: 13,
                    weight:400,

                }
            }
        },

    }


    return (
        <>
            {data ?

            <Pie
                data={data}
                options={options}
                id={'chartId'}
            />
              : <MyTicketSkeleton type={'fas fa-chart-pie'}/>
            }
        </>
    );
};


export default PieChart;
